import React from 'react';
import {_GPY} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardTeamDefaultButtons extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
			needPeriodIndex : this.props.needPeriodIndex!==undefined?this.props.needPeriodIndex:false,
	 	};
	}

	componentDidMount() {
	}

	onDeacriveSmallDependenciesComponents() {
			if ( this.props.getOnDeactiveSmallDependenciesComponents!==undefined ) {
			var l = this.props.getOnDeactiveSmallDependenciesComponents();
				for(var i=0;i<l.length;i++) {
					if(this.props.scoreboard.state.components[l[i]]!==undefined && this.props.scoreboard.state.components[l[i]].isActive()) {
						 this.props.scoreboard.state.components[l[i]].onDeactivate();
					}
				}
			}
	}

  render () {
		const sponsorLogo = this.props.scoreboard.state.currentGame.sponsorLogo!==undefined&&this.props.scoreboard.state.currentGame.sponsorLogo!==''?this.props.scoreboard.state.currentGame.sponsorLogo:"empty.png";


    return (
			<>
			<div className="row">
					<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_teamdefaults_title')}</strong></div>
					<div className="col-3 p-1">
						<GpyToggleButton keyCode="s" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_small')}
							  condition={() => {return (!this.state.needPeriodIndex || (this.state.needPeriodIndex&&this.props.scoreboard.state.currentPeriodIndex>0))}}
								onInit={() => {return {}}}
								onDeactivate={() => {
									if(this.props.onDeactivateMiniScore!== undefined){
												this.props.onDeactivateMiniScore();
									}
									if(this.props.getOnDeactiveSmallDependenciesComponents!==undefined) {
												let o = {};
												this.props.getOnDeactiveSmallDependenciesComponents().forEach((c, i) => {
													let compo = this.props.scoreboard.getComponent(c);
													if(compo!==undefined) {
															o[c] =  compo.isActive();
													}
												});
												this.setState(o);
									}
									this.onDeacriveSmallDependenciesComponents();

									return {visible: false}}}
								onActivate={() => {

									if(this.props.getOnDeactiveSmallDependenciesComponents!==undefined) {
												this.props.getOnDeactiveSmallDependenciesComponents().forEach((c, i) => {
													if(this.state[c]) {
														let compo = this.props.scoreboard.getComponent(c);
														if(compo!==undefined && !compo.isActive()) {
																compo.onActivate();
														}
													}
												});
									  }

										var res = {visible: true,
										sponsorLogo: sponsorLogo,
										game : this.props.scoreboard.state.currentGame,
										period: this.props.scoreboard.state.currentPeriodName,
										scoreHome: this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home']!==undefined ? this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home'].getScore() : 0,
										scoreGuest: this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest']!==undefined ? this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest'].getScore() : 0,
									}
									if(this.props.onMiniScore!== undefined){
												res = this.props.onMiniScore(res);
									}
									console.log("onMINI_RES",res);
									return res;
								}}
								scoreboard={this.props.scoreboard}
								getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
								stateName={this.props.scoreboard.getName() + "_button_vs_and_score_mini"}
						/>
					</div>


					<div className="col-3 p-1">
						<GpyToggleButton keyCode="f" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_fullscreen')}
						condition={() => {return (!this.state.needPeriodIndex || (this.state.needPeriodIndex&&this.props.scoreboard.state.currentPeriodIndex>0))}}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var res = {visible: true,
								sponsorLogo: sponsorLogo,
								game : this.props.scoreboard.state.currentGame,
								period: this.props.scoreboard.state.currentPeriodName,
								scoreHome: this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home']!==undefined ? this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home'].getScore() : 0,
								scoreGuest: this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest']!==undefined ? this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest'].getScore() : 0,
							}
							if(this.props.onFullScreenScore!== undefined){
										res = this.props.onFullScreenScore(res);
							}
							return res;
							}}
					  scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_vs_and_score_full"}
						/>
					</div>


					<div className="col-3 p-1">
						<GpyToggleButton keyCode="p" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_player')}
						condition={() => {return (this.props.scoreboard.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var p = this.props.scoreboard.playerArrayByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")[0];
							var log = [];
							console.log(this.props.scoreboard.state.components['gamelog'].state.gameLog.GameLog.elements);
							this.props.scoreboard.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.playerId === p.id).forEach((e) =>  {
								var minF = (parseInt(e.timerOffset)/1000) / 60 ;
								var minI = Math.floor(minF) ;
								var formatMin = ('00'+minI).slice(-2);
								log.push("'"+formatMin + " " + e.key + " " + e.value);
							});

							return {visible: true,
								playerName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
								playerInfo : p.info!==undefined?p.info.split("\n"):[],
								playerLog: log,
								player:p,
								sponsorLogo: sponsorLogo,
								team: this.props.scoreboard.getTeamByPlayer(p),
							}}}

						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_player_info"}
						autoexpirytime="12"
						warnOnly="true"
		        />
					</div>



					<div className="col-3 p-1">
						<GpyToggleButton keyCode="r" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_referee')}
						condition={() => {return (this.props.scoreboard.state.currentGame.referees!==undefined&&this.props.scoreboard.state.currentGame.referees.Referee!==undefined&&this.props.scoreboard.state.currentGame.referees.Referee.length > 0)}}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var referees = [];
							this.props.scoreboard.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_MAIN').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_referee_role_REFEREE_MAIN') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 referees.push(name);
							});
							this.props.scoreboard.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_ASSISTANT').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_referee_role_REFEREE_ASSISTANT') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 referees.push(name);
							});
						 this.props.scoreboard.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_FOURTH').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_referee_role_REFEREE_FOURTH') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 referees.push(name);
						 });
						 this.props.scoreboard.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_FIFTH').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_referee_role_REFEREE_FIFTH') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 referees.push(name);
						 });
						 return {visible: true,
								team: this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM,
								title: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_referee_overlay_title'),
								sponsorLogo: sponsorLogo,
								refereeList:referees,
						}}}

						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_referee_info"}
						autoexpirytime="15"
						warnOnly="true"
					  />
					</div>
      </div>


			<div className="row">
					<div className="col-3 p-1">
						<GpyToggleButton keyCode="H" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_hometeam')}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var playerList = [];
							this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_PLAYER')).forEach((p)=>{
								var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								playerList.push(name);
							});

							var playerListSub = [];
							this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_SUBSTITUE')).forEach((p)=>{
								var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								playerListSub.push(name);
							});

							var coachList = [];
							this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_COACH')).forEach((p)=>{
							 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
							 coachList.push(name);
							});

							return {visible: true,
								team : this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM,
								title: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_hometeam_overlay_title'),
								sponsorLogo: sponsorLogo,
								playerList:playerList,
								substitueList:playerListSub,
								coachList:coachList,
							}}}
						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_home_team_info"}
						autoexpirytime="12"
						warnOnly="true"
           />
					</div>

					<div className="col-3 p-1">
						<GpyToggleButton keyCode="G" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_guestteam')}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var playerList = [];
							this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_PLAYER')).forEach((p)=>{
								var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								playerList.push(name);
							});
							var playerListSub = [];
							this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_SUBSTITUE')).forEach((p)=>{
								var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								playerListSub.push(name);
							});
							var coachList = [];
						 this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_COACH')).forEach((p)=>{
							var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
							coachList.push(name);
						 });
							return {visible: true,
								team: this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM,
								title: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_guestteam_overlay_title'),
								sponsorLogo: sponsorLogo,
								playerList:playerList,
								substitueList:playerListSub,
								coachList:coachList,
						}}}
						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_guest_team_info"}
						autoexpirytime="12"
						warnOnly="true"
					 />
					</div>


					<div className="col-3 p-1">
						<GpyToggleButton keyCode="c" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_coach')}
						condition={() => {return (this.props.scoreboard.playerCountByRole("HOME_TEAM_COACH,GUEST_TEAM_COACH")===1)}}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {

							var p = this.props.scoreboard.playerArrayByRole("HOME_TEAM_COACH,GUEST_TEAM_COACH")[0];
							return {visible: true,
								title: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_coach_overlay_title'),
								sponsorLogo: sponsorLogo,
								coach:p,
								coachName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
								coachInfo : p.info!==undefined?p.info.split("\n"):[],
								team: this.props.scoreboard.getTeamByCoach(p),
						  }}}
						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_coach_info"}
						autoexpirytime="15"
            warnOnly="true"
					 />
					</div>

					<div className="col-3 p-1">
						<GpyToggleButton keyCode="C" title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_crew')}
						condition={() => {return (this.props.scoreboard.state.currentGame.crews!==undefined&&this.props.scoreboard.state.currentGame.crews.Crew!==undefined&&this.props.scoreboard.state.currentGame.crews.Crew.length > 0)}}
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							var crews = [];
							this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_COMMENTATOR').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_COMMENTATOR') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 crews.push(name);
							});
							this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_STREAMING_OPERATOR').forEach((p)=>{
									var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_STREAMING_OPERATOR') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
									crews.push(name);
							});
							this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_CAMERA_OPERATOR').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_CAMERA_OPERATOR') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 crews.push(name);
							});
						 this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_SOUND_TECHNICIAN').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_SOUND_TECHNICIAN') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 crews.push(name);
						 });
						 this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_GRAPHIC').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_GRAPHIC') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 crews.push(name);
						 });
						 this.props.scoreboard.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_ASSISTANT').forEach((p)=>{
								 var name = _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_games_crew_role_CREW_ASSISTANT') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
								 crews.push(name);
						 });
						 return {visible: true,
								title: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_crew_overlay_title'),
								sponsorLogo: sponsorLogo,
								crewList:crews,
						}}}
						scoreboard={this.props.scoreboard}
						getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						stateName={this.props.scoreboard.getName() + "_button_crew_info"}
						autoexpirytime="15"
						warnOnly="true"
          />
					</div>

					<div className="col-3 p-1">
					<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_info_button_lineup')}
							onInit={() => {return {}}}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {
								visible: true,
								game : this.props.scoreboard.state.currentGame,
							}}}
							scoreboard={this.props.scoreboard}
							getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
							stateName={this.props.scoreboard.getName() + "_button_lineup"}
					/>
					</div>

					<div className="col-3 p-1">
					<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_clock_button')}
							onInit={() => {return {}}}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {visible: true,
							gmt: (Math.abs(new Date().getTimezoneOffset()/60)),
						}}}
							scoreboard={this.props.scoreboard}
							getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
							stateName={this.props.scoreboard.getName() + "_button_analog_clock"}
							/>
					</div>

			</div>



		 </>
		);
  }

}
export default ScoreboardTeamDefaultButtons;
